import { render, staticRenderFns } from "./ElectricMeterDescription.vue?vue&type=template&id=12b13fe0&scoped=true"
import script from "./ElectricMeterDescription.vue?vue&type=script&lang=ts"
export * from "./ElectricMeterDescription.vue?vue&type=script&lang=ts"
import style0 from "./ElectricMeterDescription.vue?vue&type=style&index=0&id=12b13fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b13fe0",
  null
  
)

export default component.exports